// for checking value is number or not
const isInt = (n: string | number) => {
    if (Number.isNaN(Number(n))) {
        return;
    }
    const number = +n;
    return number % 1 === 0;
};

const isFloat = (n: string | number) => {
    if (Number.isNaN(Number(n))) {
        return;
    }
    const number = +n;
    return number % 1 !== 0;
};

export { isInt, isFloat };
